import { render, staticRenderFns } from "./PlayerListItemComponent.vue?vue&type=template&id=25f6c22b&"
import script from "./PlayerListItemComponent.vue?vue&type=script&lang=js&"
export * from "./PlayerListItemComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports